/* eslint-env browser */
import LastSearchesBox from './LastSearchesBox';

const ele = document.getElementById('last-searches');
if (ele) {
    const lastSearchesBox = new LastSearchesBox(ele);
    lastSearchesBox.init();
}
